"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollection = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../id");
var collection_data_1 = require("./collection.data");
var collection_loader_1 = require("./collection.loader");
var capture_provider_1 = require("./fields/provider/capture.provider");
var collection_provider_1 = require("./fields/provider/collection.provider");
var collection_model_read_1 = require("./serializer/collection.model.read");
var ReadUtil = tslib_1.__importStar(require("./serializer/collection.model.util"));
var collection_model_write_1 = require("./serializer/collection.model.write");
var collection_upgrade_1 = require("./upgrade/collection.upgrade");
var IkeModelCollection = /** @class */ (function () {
    function IkeModelCollection() {
    }
    IkeModelCollection.prototype.loader = function () {
        return new collection_loader_1.IkeCollectionLoaderFromState();
    };
    IkeModelCollection.prototype.upgrade = function (collections, targetForm) {
        return new collection_upgrade_1.IkeCollectionUpgrade(collections, targetForm);
    };
    IkeModelCollection.prototype.create = function (form, loader) {
        var collection = new collection_data_1.CollectionModel(form, loader);
        collection.state.uuid = id_1.IkeId.v4();
        collection.state.revision = collection.state.instanceId = id_1.IkeId.generate();
        collection.state.createdAt = collection.state.updatedAt = new Date();
        return collection;
    };
    IkeModelCollection.prototype.read = function (collection, schema, loader) {
        var reader = new collection_model_read_1.IkeModelCollectionReader(collection, schema, loader);
        return reader.read();
    };
    IkeModelCollection.prototype.write = function (model) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectedAt, collectionJSON;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, model.getCollectedAt()];
                    case 1:
                        collectedAt = _a.sent();
                        collectionJSON = {
                            objectId: model.id,
                            v: IkeModelCollection.JSON_VERSION_LATEST,
                            uuid: model.uuid,
                            data: {
                                recordeduuid: model.uuid,
                                uuid: model.schema.rootFormId,
                                version: model.schema.revision,
                                data: collection_model_write_1.IkeModelCollectionWriter.writeData(model)
                            },
                            formuuid: model.schema.rootFormId,
                            formversion: model.schema.revision,
                            jobuuid: model.jobId,
                            measurements: collection_model_write_1.IkeModelCollectionWriter.writeCollectionMeasurements(model),
                            brightnessCorrections: collection_model_write_1.IkeModelCollectionWriter.writeCollectionBrightnessCorrections(model),
                            cropParameters: collection_model_write_1.IkeModelCollectionWriter.writeCollectionCropParameters(model),
                            imageVisibilities: collection_model_write_1.IkeModelCollectionWriter.writeImageVisibilities(model),
                            revision: model.revision,
                            collectedBy: model.collectedBy,
                            collectedWith: model.collectedWith,
                            assignedTo: model.assignedTo,
                            collectedAt: core_api_1.ParseJSON.toDate(collectedAt),
                            createdAt: model.createdAt != null ? model.createdAt.toISOString() : null,
                            updatedAt: model.updatedAt != null ? model.updatedAt.toISOString() : null,
                            updatedBy: model.updatedBy
                        };
                        if (collectedAt !== model.createdAt && collectedAt != null) {
                            collectionJSON.data.createdat = collectedAt.getTime() / 1000;
                        }
                        return [2 /*return*/, collectionJSON];
                }
            });
        });
    };
    /**
     * Build a collection summary from a collection model.
     *
     * TODO: `link`, `updatedBy`, and `tags` are not fully implemented.
     */
    IkeModelCollection.prototype.summary = function (model) {
        var summaryObject = {
            objectId: model.id,
            collectionId: model.id,
            revision: model.revision,
            uuid: model.uuid,
            formRevision: model.schema.revision,
            createdAt: model.createdAt.toISOString(),
            updatedAt: model.updatedAt.toISOString(),
            collectedAt: core_api_1.ParseJSON.toDate(model.collectedAt),
            collectedBy: model.collectedBy,
            collectedWith: model.collectedWith,
            assignedTo: model.assignedTo,
            links: collection_provider_1.CollectionProvider.getCollectionIds(model),
            updatedBy: [model.updatedBy],
            title: model.title,
            subtitle: model.subtitle,
            siteType: model.siteType,
            dropPole: model.dropPole,
            poleLoading: model.poleLoading,
            mapMarkerColor: model.mapMarkerColor,
            status: null,
            location: core_api_1.ParseJSON.toGeoPoint(model.location),
            captureIds: capture_provider_1.CaptureProvider.getCaptureIds(model),
            tags: [model.jobId]
        };
        var statusField = model.status;
        if (statusField != null) {
            if (statusField.hasValue()) {
                summaryObject.status = statusField.displayValue;
            }
        }
        return summaryObject;
    };
    IkeModelCollection.prototype.getCaptureUUIDs = function (collection) {
        var e_1, _a;
        var collectionCaptureData = ReadUtil.findObjectsWhere(collection, ReadUtil.isCaptureData);
        var uuidMap = {};
        try {
            for (var collectionCaptureData_1 = tslib_1.__values(collectionCaptureData), collectionCaptureData_1_1 = collectionCaptureData_1.next(); !collectionCaptureData_1_1.done; collectionCaptureData_1_1 = collectionCaptureData_1.next()) {
                var captureData = collectionCaptureData_1_1.value;
                var uuid = captureData.camera.imageuuid;
                if (uuid != null && !uuidMap[uuid]) {
                    uuidMap[uuid] = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (collectionCaptureData_1_1 && !collectionCaptureData_1_1.done && (_a = collectionCaptureData_1.return)) _a.call(collectionCaptureData_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return Object.keys(uuidMap);
    };
    IkeModelCollection.prototype.getLinkUUIDs = function (collection) {
        var e_2, _a;
        var collectionLinkData = ReadUtil.findObjectsWhere(collection, ReadUtil.isLink);
        var uuidMap = {};
        try {
            for (var collectionLinkData_1 = tslib_1.__values(collectionLinkData), collectionLinkData_1_1 = collectionLinkData_1.next(); !collectionLinkData_1_1.done; collectionLinkData_1_1 = collectionLinkData_1.next()) {
                var linkData = collectionLinkData_1_1.value;
                var uuid = linkData.collectionUuid;
                if (uuid != null && !uuidMap[uuid]) {
                    uuidMap[uuid] = true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (collectionLinkData_1_1 && !collectionLinkData_1_1.done && (_a = collectionLinkData_1.return)) _a.call(collectionLinkData_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return Object.keys(uuidMap);
    };
    IkeModelCollection.prototype.getCalibrationIds = function (captures) {
        var e_3, _a;
        var calibrationIdMap = {};
        try {
            for (var captures_1 = tslib_1.__values(captures), captures_1_1 = captures_1.next(); !captures_1_1.done; captures_1_1 = captures_1.next()) {
                var capture = captures_1_1.value;
                var calibrationId = capture.calibrationid;
                if (calibrationId != null && !calibrationIdMap[calibrationId]) {
                    calibrationIdMap[calibrationId] = true;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (captures_1_1 && !captures_1_1.done && (_a = captures_1.return)) _a.call(captures_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return Object.keys(calibrationIdMap);
    };
    IkeModelCollection.prototype.getFileIds = function (collection) {
        var e_4, _a;
        var collectionFileData = ReadUtil.findObjectsWhere(collection, ReadUtil.isFileData);
        var idMap = {};
        try {
            for (var collectionFileData_1 = tslib_1.__values(collectionFileData), collectionFileData_1_1 = collectionFileData_1.next(); !collectionFileData_1_1.done; collectionFileData_1_1 = collectionFileData_1.next()) {
                var fileData = collectionFileData_1_1.value;
                var id = fileData.attachmentId;
                if (id != null && !idMap[id]) {
                    idMap[id] = true;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (collectionFileData_1_1 && !collectionFileData_1_1.done && (_a = collectionFileData_1.return)) _a.call(collectionFileData_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return Object.keys(idMap);
    };
    /** v3 collections have had their captures extracted into the capture file table */
    IkeModelCollection.JSON_VERSION_3_PARSE_API = 3;
    /** v4 Collections have re-mapped their captures to include the objectId and raw values of the actual capture. */
    IkeModelCollection.JSON_VERSION_4_CAPTURE_FIXED = 4;
    /** v5 Collections  */
    IkeModelCollection.JSON_VERSION_5_BRIGHTNESS_CORRECTION_ADDED = 5;
    /** v6 Collections  */
    IkeModelCollection.JSON_VERSION_6_CROP_PARAMETER_ADDED = 6;
    IkeModelCollection.JSON_VERSION_LATEST = 6;
    return IkeModelCollection;
}());
exports.IkeModelCollection = IkeModelCollection;
//# sourceMappingURL=collection.model.js.map